import React from 'react';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { keyToTitle } from 'utils';
import { isPlainObject, isBoolean } from 'lodash';

const SchemaValues = ({ data, schema }) => {
  const renderData = (data, key, schema) => {
    const property = schema?.properties?.find((item) => item.name === key);

    return isPlainObject(data) ? (
      <Box>
        <span data-cy={'label'} className="label">
          {' '}
          {keyToTitle(key)}{' '}
        </span>
        <Box>{Object.entries(data)?.map(([key, value]) => renderData(value, key, schema))}</Box>
      </Box>
    ) : (
      <Typography key={key} color="textSecondary" style={{ lineHeight: 1, marginBottom: 4 }}>
        {schema ? (
          <>
            <Box data-cy={'schema-label'} fontSize={12} fontWeight="fontWeightMedium">
              {property ? property.label : `${keyToTitle(key)}: `}
            </Box>
            <Box data-cy={'schema-value'} fontSize={12} component="span">
              {' '}
              {isBoolean(data) ? (data ? 'True' : 'False') : data === null ? 'null' : data}
            </Box>
          </>
        ) : (
          <Box data-cy={'value'} fontSize={12} fontWeight="fontWeightMedium">
            {isBoolean(data) ? (data ? 'True' : 'False') : data === null ? 'null' : data}
          </Box>
        )}
      </Typography>
    );
  };

  return (
    <Box>
      {Object.keys(data || {}).length > 0 && <Box pb={2}>{renderData(data, '', schema)}</Box>}
    </Box>
  );
};

SchemaValues.propTypes = {
  data: PropTypes.object.isRequired,
  schema: PropTypes.object,
};

export default SchemaValues;
